export function initUsercentricsConsent() {
  const isProd =
    window.location.hostname === "apollofinancial.ie" ||
    window.location.hostname === "www.apollofinancial.ie";

  if (!isProd || document.getElementById("usercentrics-cmp")) return;

  const loadScript = () => {
    const script = document.createElement("script");
    script.id = "usercentrics-cmp";
    script.src = "https://web.cmp.usercentrics.eu/ui/loader.js";
    script.async = true;
    script.setAttribute("data-settings-id", "4hVSZrdXDIjuvw");
    script.setAttribute("data-blockingmode", "auto");
    document.head.appendChild(script);
  };

  if ("requestIdleCallback" in window) {
    requestIdleCallback(loadScript);
  } else {
    setTimeout(loadScript, 3000);
  }

  let hasInjected = false;

  window.addEventListener("UC_UI_INITIALIZED", () => {
    if (hasInjected || !window.Usercentrics) return;

    hasInjected = true;

    window.Usercentrics.addEventListener("consentChanged", (event: any) => {
      const hasMarketingConsent = event?.consents?.some(
        (consent: any) =>
          consent.template?.category === "Marketing" && consent.status === true
      );

      if (!hasMarketingConsent) return;

      // Inject GTM
      if (!document.getElementById("gtm-script")) {
        const gtm = document.createElement("script");
        gtm.id = "gtm-script";
        gtm.src = "https://www.googletagmanager.com/gtm.js?id=GTM-MFSK96LF";
        gtm.async = true;
        document.body.appendChild(gtm);
      }

      // Inject FB Pixel
      if (!document.getElementById("fb-pixel-script")) {
        const fb = document.createElement("script");
        fb.id = "fb-pixel-script";
        fb.src = "https://connect.facebook.net/en_US/fbevents.js";
        fb.async = true;
        fb.onload = () => {
          if (!window.fbq) {
            const fbqFunc: FbqFunction = function (...args: any[]) {
              if (fbqFunc.callMethod) {
                fbqFunc.callMethod(...args);
              } else {
                fbqFunc.queue?.push(args);
              }
            };
            fbqFunc.queue = [];
            fbqFunc.loaded = true;
            fbqFunc.version = "2.0";
            window.fbq = fbqFunc;
          }

          window.fbq("init", "955801566740788");
          window.fbq("track", "PageView");
        };
        document.body.appendChild(fb);
      }
    });
  });
}
